import React from 'react';
import { bool } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { isScrollingDisabled } from '../../ducks/ui.duck';
import privacyPolicyContent from '../../content/privacyPolicyContent';

import {
  StaticContentArticle,
  StaticContentPageLayout,
} from '../StaticContentPage/StaticContentPage';

export const PrivacyPolicyContent = props => (
  <StaticContentArticle content={privacyPolicyContent} {...props} />
);

export const PrivacyPolicyPageComponent = props => {
  const { scrollingDisabled } = props;
  return <StaticContentPageLayout content={privacyPolicyContent} scrollingDisabled={scrollingDisabled} />;
};

PrivacyPolicyPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,
};

const mapStateToProps = state => ({
  scrollingDisabled: isScrollingDisabled(state),
});

const PrivacyPolicyPage = compose(connect(mapStateToProps))(PrivacyPolicyPageComponent);

export default PrivacyPolicyPage;
